import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';

const GizlilikPolitikasi = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          align="center"
          fontWeight="bold"
        >
          Gizlilik Politikası
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Typography
            variant="h5"
            component="h2"
            gutterBottom
            fontWeight="bold"
          >
            1. Genel Bakış
          </Typography>
          <Typography paragraph>
            Bu Gizlilik Politikası, KONVOY uygulamasının kişisel verilerinizi
            nasıl topladığını, kullandığını, paylaştığını ve koruduğunu
            açıklamaktadır. Uygulamamızı kullanarak, bu politikada belirtilen
            uygulamaları kabul etmiş olursunuz.
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography
            variant="h5"
            component="h2"
            gutterBottom
            fontWeight="bold"
          >
            2. Kamera Erişimi
          </Typography>
          <Typography paragraph>
            Uygulamamız, aşağıdaki amaçlar için cihazınızın kamerasına erişim
            talep edebilir:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>Belge ve formların fotoğraflarını çekmek</li>
            <li>Yük ve kargo durumunu belgelemek</li>
            <li>QR kodları ve barkodları taramak</li>
            <li>Kimlik doğrulama süreçleri için</li>
          </Typography>
          <Typography paragraph>
            Kamera erişimi yalnızca açık izninizle etkinleştirilir ve
            istediğiniz zaman cihaz ayarlarınızdan bu izni kaldırabilirsiniz.
            Kamera ile çekilen görüntüler, yalnızca belirtilen amaçlar için
            kullanılır ve güvenli sunucularımızda şifreli olarak saklanır.
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography
            variant="h5"
            component="h2"
            gutterBottom
            fontWeight="bold"
          >
            3. Konum Erişimi
          </Typography>
          <Typography paragraph>
            Uygulamamız, aşağıdaki amaçlar için cihazınızın konum bilgilerine
            erişim talep edebilir:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>Yük ve araç takibi</li>
            <li>Rota optimizasyonu ve navigasyon</li>
            <li>Yakındaki tesisleri ve hizmetleri göstermek</li>
            <li>Teslimat ve alım noktalarını doğrulamak</li>
          </Typography>
          <Typography paragraph>
            Konum erişimi yalnızca açık izninizle etkinleştirilir ve istediğiniz
            zaman cihaz ayarlarınızdan bu izni kaldırabilirsiniz. Konum
            verileriniz, yalnızca belirtilen amaçlar için kullanılır ve güvenli
            sunucularımızda şifreli olarak saklanır.
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography
            variant="h5"
            component="h2"
            gutterBottom
            fontWeight="bold"
          >
            4. Veri Saklama ve Güvenlik
          </Typography>
          <Typography paragraph>
            Kişisel verileriniz, endüstri standardı güvenlik önlemleri
            kullanılarak korunmaktadır. Verileriniz, yasal gerekliliklere uygun
            olarak ve hizmetlerimizi sağlamak için gerekli olan süre boyunca
            saklanır. Verilerinizin güvenliğini sağlamak için teknik ve
            organizasyonel önlemler alıyoruz.
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography
            variant="h5"
            component="h2"
            gutterBottom
            fontWeight="bold"
          >
            5. Haklarınız
          </Typography>
          <Typography paragraph>
            Kişisel verilerinizle ilgili olarak aşağıdaki haklara sahipsiniz:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>Verilerinize erişim talep etme</li>
            <li>Verilerinizin düzeltilmesini talep etme</li>
            <li>Verilerinizin silinmesini talep etme</li>
            <li>Veri işlemeye itiraz etme</li>
            <li>Veri taşınabilirliği talep etme</li>
          </Typography>
          <Typography paragraph>
            Bu haklarınızı kullanmak için bizimle iletişime geçebilirsiniz.
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography
            variant="h5"
            component="h2"
            gutterBottom
            fontWeight="bold"
          >
            6. İletişim
          </Typography>
          <Typography paragraph>
            Bu gizlilik politikası hakkında sorularınız veya endişeleriniz
            varsa, lütfen aşağıdaki iletişim bilgilerini kullanarak bizimle
            iletişime geçin:
          </Typography>
          <Typography paragraph>
            E-posta: privacy@unoweb.com
            <br />
            Telefon: +90 212 123 4567
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h6" component="p" align="center">
            Son güncelleme: {new Date().toLocaleDateString('tr-TR')}
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default GizlilikPolitikasi;
